import { environment } from "./Request";

const API_CONFIG = {
    // User Authentication
    ADMIN_LOGIN: environment.API_URL + 'kc/keycloak/login',
    CREATE_PASSWORD: environment.API_URL + 'kc/keycloak/change-password',
    SEND_OTP: environment.API_URL + 'kc/keycloak/send-otp',
    VERIFY_OTP: environment.API_URL + 'kc/keycloak/validate-otp',
    LOG_OUT_USER: environment.API_URL + 'kc/keycloak/logout',
    // Store API
    GET_STORE_LIST: environment.API_URL + 'store/filter-search',
    GET_STORE_DASHBOARD_DATA: environment.API_URL + 'store/get_dash',
    DOWNLOAD_STORE_LIST: environment.API_URL + 'store/download',
    UPLOAD_STORE_LIST: environment.API_URL + 'store/store-bulk-upload',
    GET_STORE_DETAILS_BY_ID: environment.API_URL + 'Store/by-id',
    UPDATE_STORE_STATUS: environment.API_URL + 'store/update-status',
    CREATE_STORE: environment.API_URL + 'store',
    GET_ALL_BRANDS_LIST: environment.API_URL + 'brand/names',
    GET_ALL_BRANDS_LIST_CONTRACt: environment.API_URL + 'contract/brand-list',
    GET_LIST_DATE_RANGE: environment.API_URL + 'contract/range-list',
    CREATE_BRAND_CONTRACT: environment.API_URL + 'contract',
    VIEW_BRAND_CONTRACT: environment.API_URL + 'contract/view',
    UPLOAD_BULK_CONTRACT: environment.API_URL + 'contract/bulk-upload',
    //Brand API
    GET_BRAND_LIST: environment.API_URL + 'brand/get-brand',
    CREATE_BRAND_LIST: environment.API_URL + 'brand/create-brand',
    UPDATE_BRAND_DETAILS: environment.API_URL + 'brand/update-brand',
    UPDATE_BRAND_STATUS: environment.API_URL + 'brand/update-status',
    GET_ALL_BRANDS: environment.API_URL + 'brand/storeCount',
    GET_BRAND_DASHBOARD_DATA: environment.API_URL + 'brand/brandDashboard',
    CREAT_BRAND: environment.API_URL + 'brand',
    DOWNLOAD_BRAND_LIST: environment.API_URL + 'brand/download',
    UPLOAD_BRAND_MASTER_DATA: environment.API_URL + 'background/itemMasterUpload',
    DOWNLOAD_BRAND_MASTER_DATA: environment.API_URL + 'brand/item-master-download',
    GET_BRAND_MASTER_DATA: environment.API_URL + 'brand/item-master',
    BRAND_RECON_HEADERS: environment.API_URL + 'sales/recon-headers',
    
    //User Management
    GET_USER_LIST: environment.API_URL + 'user/getUserRecord',
    BULK_CREATE_USERS: environment.API_URL + 'user/bulk_users',
    CREATE_USER: environment.API_URL + 'user/',
    UPDATE_USER: environment.API_URL + 'user/updateUserDetails',
    GET_REPORTING_MANAGER: environment.API_URL + 'user/getUserDropDown',
    GET_TEME_HIERARCHY_MANAGER_LIST: environment.API_URL + 'user/hierarchy-view',
    DOWNLOAD_USER_MANGMENT_REPORTS: environment.API_URL + 'user/download',
    //Reports
    GET_UNPROCESSED_REPORTS: environment.API_URL + 'report/unprocessedFilesList',
    GET_CONSOLIDATED_REPORTS: environment.API_URL + 'report/brandsReportMonthWise',
    REFRESH_COSOLIDATED_REPORTS: environment.API_URL + 'background/getConsolidatedReport',
    REFRESH_RECON_REPORTS: environment.API_URL + 'background/downloadReconcilationFile',
    REFRESH_ALL_RECON_REPORTS: environment.API_URL + 'background/update-all-reconcilation',
    DOWNLAOD_STOCK_COSOLIDATED_REPORTS: environment.API_URL + 'report/getConsolidatedReport',
    DOWNLOAD_UNPROCESSED_REPORT: environment.API_URL + 'report/preSignedUrl',
    //Core
    GET_FINANCIAL_YEAR_LIST: environment.API_URL + 'core/fyYears',
    GET_TEMPLATE_OF_TABLE: environment.API_URL + 'core/getTemplate',
    GET_CREATE_BRAND_DROPDOWN_LIST: environment.API_URL + 'core/get_dropdown',
    GET_LIST_STATE_CITY_BY_PINCODE: environment.API_URL + 'core/addres',
    FILE_UPLOAD: environment.API_URL + 'core/fileUpload',
    GET_DROPDOWN_MASTER: environment.API_URL + 'core/get_dropdown',
    UPLOAD_SALES_STOCK_REPORT: environment.API_URL + 'background/upload-reports',
    UPLOAD_SALES_STOCK_REPORT_PT_FILE: environment.API_URL + 'background/upload-stock-report-pt-file',
    GET_USER_BRAND_STATE: environment.API_URL + 'core/states',
    GET_STYLE_CODE: environment.API_URL + 'core/style-code',
    GET_REGIONS: environment.API_URL + 'core/region',
    GET_BARCODES: environment.API_URL + 'core/barcode',
    DOWNLOAD_COSOLIDATED_REPORTS: environment.API_URL + 'core/reports',
    CREATE_CUSTOM_REPORTS: environment.API_URL + 'background/custom-consolidated-report',
    RUN_BACKGROUND_JOBS: environment.API_URL + 'background/runFullApis',
    GET_CUSTOM_REPORTS: environment.API_URL + 'core/custom-list-reports',
    CREATE_CUSTOM_RECON_REPORTS: environment.API_URL + 'background/custom-recon-report',
    UPLOAD_RETURN_STOCK_REPORT: environment.API_URL + 'background/upload-stock-return',

    // RULE MANGAMNET
    GET_REPORT_HEADER_VALUES: environment.API_URL + 'core/reportHeader',
    GET_BRAND_NAME: environment.API_URL + 'brand/names',
    GET_STORE_CUSTOMER_NAME: environment.API_URL + 'store/customer-names',
    GET_HEADER_VALUE_ONLY: environment.API_URL + 'core/headerValues',
    CREATE_RULE_MANGMENT: environment.API_URL + 'core/reportHeader',
    UPDATE_RULE_MANGMENT: environment.API_URL + 'core/updateReportHeader',
    //Feedback
    GET_FEEDBACK_LIST: environment.API_URL + 'user/getFeedback',
    UPDATE_FEEDBACK_DEAILS: environment.API_URL + 'user/updateFeedback',
    CREATE_FEEDBACK: environment.API_URL + 'user/addFeedback',
    // Sales
    GET_SALES_YEAR: environment.API_URL + 'sales/salesViewRange',
    GET_SALES_DASHBOARD_DATA: environment.API_URL + 'sales/salesDashboard',
    DOWNLOAD_SALES_DASHBOARD_DATA: environment.API_URL + 'sales/detailsDownload',
    DOWNLOAD_SALES_RECON_DATA: environment.API_URL + 'sales/downloadReconcilationFile',
    GET_FILTER_DATA_FOR_SALES: environment.API_URL + 'sales/store-region-state',
    DOWNLOAD_STORE_SALES: environment.API_URL + 'sales/invoice-gap-list-download',
    GET_STORE_SALES: environment.API_URL + 'sales/invoice-gap-list',
    SEND_SALE_REPORT_BY_EMAIL: environment.API_URL + 'background/send-sale-report-intimation',
    SEND_RECON_REPORT_BY_EMAIL: environment.API_URL + 'background/send-recon-report-intimation',
    SALES_RECON_STORE_LIST: environment.API_URL + 'sales/recon-sore-list',
    //Stock
    GET_STOCK_DASHBOARD_DATA: environment.API_URL + 'stock/stockDashboard',
    DOWNLOAD_DASHBOARD_REPORT: environment.API_URL + 'stock/detailsDownload',
    DOWNLOAD_BROKEN_SIZE_REPORT: environment.API_URL + 'replanisment/generate-templet',
    GET_FILTER_DATA_FOR_STOCK: environment.API_URL + 'stock/store-region-state',
    UPLOAD_BROKEN_SIZE_FILE: environment.API_URL + 'background/upload-key-sizes',
    REPLENISHMENT_FILE: environment.API_URL + 'replanisment/replanishment-sore-list',
    GET_STOCK_DASHBOARD_CARDS_DATA: environment.API_URL + 'stock/fetch-stock-history-of-current-month',
    //Target Vs Achievement
    FETCH_TARGET_VS_ACHIEVEMENT_LIST: environment.API_URL + 'target-achievement',
    DOWNLOAD_TARGET_VS_ACHIEVEMENT_LIST: environment.API_URL + 'target-achievement/download',
    DOWNLOAD_TEMPLETE_TARGET_VS_ACHIEVEMENT_LIST: environment.API_URL + 'target-achievement/download_templete',
    BULK_INSERT: environment.API_URL + 'target-achievement/bulk-insert',
    TARGET_VS_ACHIEVEMENT_DASHBOARD_DATA: environment.API_URL + 'target-achievement/dashboard',
    // incentive/
    CREATE_INCENTIVE: environment.API_URL + 'incentive/create-incentive',
    INCENTIVE_HISTORY: environment.API_URL + 'incentive/history-incentive',
    GET_USER_INCENTIVE: environment.API_URL + 'incentive/user-incentive',
    DOWNLOAD_USER_INCENTIVE: environment.API_URL + 'incentive/download-incentive',
    GET_STORES_FOR_INCENTIVE: environment.API_URL + 'incentive/incentive-stores',
    // Promotion
    GET_PROMOTIONS_LIST: environment.API_URL + 'promotions/get-promotions',
    UPDATE_PROMOTIONS_LIST: environment.API_URL + 'promotions/bulk-update-promotion',
    VIEW_PROMOTIONS: environment.API_URL + 'promotions/view-promotion',
    DOWNLOAD_PROMOTION_LIST: environment.API_URL + 'promotions/download',
    CREATE_NEW_PROMOTION: environment.API_URL + 'promotions/create-promotion',
    FETCH_LATEST_PROMOTION_NUMBER: environment.API_URL + 'promotions/fetch-latest-promo-code-new',
    DELETE_PROMOTION: environment.API_URL + 'promotions/delete',
    GET_SEASONS: environment.API_URL + 'Stock/all-seasons',
    GET_CATEGORY_BY_BRAND: environment.API_URL + 'Stock/brand-category',
    GET_SUB_BRAND_LIST:  environment.API_URL + 'Stock/sub-brand',
    EMAIL_PROMOTION: environment.API_URL + 'background/send-promotion-email',

   
    // Employee Status
    GET_ALL_EMPLOYEE_STATUS: environment.API_URL + 'user/employee-status',
    GET_ALL_SALES_DETAILS: environment.API_URL + 'user/employee-sales',
    GET_ALL_ATTENDANCE_DETAILS: environment.API_URL + 'user/employee-attendance',
    DOWNLOAD_EMPLOYEE_STATUS: environment.API_URL + 'user/download-status',
    //Notifications
    SUBMIT_NOTIFICATION_DATA: environment.API_URL + 'notifications/send-notification',
    GET_NOTIFICATION_LIST: environment.API_URL + 'notifications',

    // File Center
    GET_UPLOADED_FILE_LIST: environment.API_URL + 'file-center/fetch-uploaded-files',
    GET_STORE_CONTRACT_LIST: environment.API_URL + 'file-center/fetch-all-stores',
    GET_RETRY_FILE_PROCESS: environment.API_URL + 'file-center/retry-file-process',
};

export default API_CONFIG;
